import { Fragment, useEffect, useState, useRef } from "react";
import { Switch } from "@headlessui/react";
import LayoutMenu from "../pagos-administrativo/components/LayoutMenu";

import { Disclosure, Transition } from '@headlessui/react'

import { Combobox } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon, XMarkIcon, ExclamationTriangleIcon } from '@heroicons/react/20/solid'
import { FunnelIcon, ArrowUpIcon, ArrowDownIcon } from '@heroicons/react/20/solid'

const statuses = {
  Pagada: { Color: 'text-green-600 bg-green-100 ring-green-400/10', Texto: 'text-green-400', IconoS: CheckIcon, },
  Pendiente: { Color: 'text-yellow-700 bg-yellow-100 ring-yellow-400/10', Texto: 'text-yellow-400', IconoS: ExclamationTriangleIcon, },
  Vencida: { Color: 'text-red-700 bg-red-100 ring-red-400/10', Texto: 'text-red-400', IconoS: XMarkIcon, },
}

// para pagos
/* Tipos de tags soportados en el grid 
  link: hiper vínculo
  button: botón cuadrado
  switch: toggle button
  textBox : cuadros de texto
  text: solo texto

*/

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const ResultadoDataGrid = ({
  isCatalogo = false,
  isRetiro = false,
  handleGridInput,
  setEstado=()=>{},
  showDialogoPlan4 = false,
  alumnos = [],
  handleAlumno,
  columnas=[],
  titulo = "",
  subtitulo = "",
  seleccion = false,
  swicht = false,
  enabled,
  handleClick=()=>{},
  reinscrito,
  confiable = false,
  preautorizado = false,
  tipoGrid = "",
  txtInventario='',
  handleChangeTextbox=()=>{},
  textos,
  perfil,
  traslado = 0,
}) => {
  //console.log(columnas)
  const [width] = useState(window.screen.width);
  const [height] = useState(window.screen.height);
  const [position, setPosition] = useState("");
  const [dropDown, setDropDown] = useState(false);
  const storeRefs = useRef([]);

  const [isShowing, setIsShowing] = useState(false)
  const [isOrden, setIsOrden] = useState(false)

  //storeRefs.current = [];

  const [query, setQuery] = useState('')
  const [selectedPerson, setSelectedPerson] = useState(alumnos)

  const [dataAlumnos, setdataAlumnos] = useState(alumnos)

  const filteredAlumnos =
    query === ''
      ? alumnos
      : alumnos.filter((x) =>
        x.Carnet
          .toLowerCase()
          .replace(/\s+/g, '')
          .includes(query.toLowerCase().replace(/\s+/g, ''))
      )

  const handleFilterClose = () => {
    if (isShowing === true) {
      setQuery('')
      setSelectedPerson('')
      setdataAlumnos(alumnos)
    }
    setIsShowing((isShowing) => !isShowing)
  }


  const handleOrder = () => {
    const data = alumnos.sort((a, b) => {
      if (isOrden === true) {
        if (a.Carnet < b.Carnet) {
          return -1;
        }
      } else {
        if (a.Carnet > b.Carnet) {
          return -1;
        }
      }
    });
    setIsOrden((isShowing) => !isShowing)
    setdataAlumnos(data)
    // console.log('Orden', data)
  }

  const handleFilterA = (alumno, id) => {
    let dataA = []
    dataA = [...alumnos.filter(a => { return Object.values(a)[id] === Object.values(alumno)[id] })]

    if (dataA.length === 0) {
      dataA = [...alumnos]
    }
    setSelectedPerson(alumno)
    setdataAlumnos(dataA)
  }

  useEffect(() => {
    if (!isCatalogo) {
      setSelectedPerson(alumnos)
      setdataAlumnos(alumnos)
      //console.log('alumnos grid', alumnos)
      if (width > height) {
        setPosition("landscape");
      } else {
        setPosition("portrait");
      }
    }
  }, [alumnos]);// alumnos

  const textoaEnviar = (alumno, titulo, text, alt) => {
    
    let texto = "";
    // ojo, al cambiar el titulo del grid, cambiarlo aqui tambien
    switch (titulo) {
      case "Alumnos seleccionados":
        texto = alumno.Editado ? alt : text;
        break;
      case "Detalle de inventarios": 
        texto = alumno.Ajuste || alumno.AplicaAjuste === 0 ? alt : text;
        break; // alumno.AplicaAjuste ? alt : text;
      case "Alumnos":
        texto = alumno.Agregado ? alt : text;
        break;
      case "Condicionados":
        texto = alumno.Editado ? alt : text;
        break;
      case "Resultados":
        texto = alumno.PlanE === 'Plan 4' ? alt : text;
        break;
      case "Permisos":
        texto = alumno.SubMenu ? text: alt ;
        break;
      case "Alumnos plan 4":
        texto = (alumno.Inscrito && alumno.Diplomado) ? "Quitar": (alumno.Inscrito && !alumno.Diplomado)? "Agregar" : "No aplica" ;
        break;
        case "Listado de alumnos":
          texto = alumno.PlanE ? text: alt ;
          break;
        
        case "Detalle de documentos emitidos":
          texto = (alumno.Estado) ? "": "Anular" ;
          break;
        
      default:
        texto = text;
        break;
    }
    return texto;
  };

  const handleDropDown = (indice) => {
    const block = "viewFull w-[100%] overflow-hidden border rounded-br-md rounded-bl-md border-azulBrillanteMira p-1 ";
    const hidden = "hidden";

    storeRefs.current?.map((curr) => {
      if (curr.id === indice) {
        if (curr["tag"].className !== "hidden") { // si no está oculto, lo oculta y viceversa
          curr["tag"].className = hidden;
        } else {
          curr["tag"].className = block;
        }
      } else {
        curr["tag"].className = hidden; // si no cincide con el indice, los oculta
      }
    });
  };

  const addToRefs = (el, Idx) => {
    if (el && !storeRefs.current.includes(el)) {
      storeRefs.current.push({ id: Idx, tag: el });
    }
  };

  return (
    <>
      <div
        className={
          "overflow-hidden px-4 sm:px-6 lg:px-8 p-4 pb-2  divide-y divide-gray-300 " +
            confiable || preautorizado
            ? ""
            : " h-full "
        }
      >
        <div className={"sm:flex sm:items-center p-2"}>
          <div className="sm:flex-auto">
            <h1 className="text-lg font-semibold text-white">{titulo}</h1>
            <p className="text-sm text-grisMira">{subtitulo}</p>
          </div>
        </div>
        <div className="mt-2 flex flex-col p-3 pt-0 pb-0">
          <div
            className={
              "-mx-4 sm:-mx-6 " + confiable || preautorizado
                ? " lg:mx-0 "
                : " lg:-mx-8 "
            }
          >
            <div className="overflow-x-auto">
              <div className="mb-4 h-auto">
                <table
                  className="min-w-full border-separate overflow-scroll"
                  style={{ borderSpacing: 0 }}
                >
                  <thead className="bg-secundarioMira">
                    <tr>
                      {columnas?.map(({ name, id, filter = 0, ordenar = 0 }) =>
                        name !== "" && filter === 0 && ordenar === 0 ? (
                          <th
                            key={Math.random(20)}
                            scope="col"
                            className={id === 0 && position === "portrait"
                              ? " left-0 bg-secundarioMira sticky top-0 z-10 border-b border-gray-300 py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-grisMira sm:pl-6 lg:pl-8 "
                              : "bg-secundarioMira top-0 z-10 border-b border-gray-300 py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-grisMira sm:pl-6 lg:pl-8" +
                              (tipoGrid === "asistencia" ? " hidden" : "")}
                          >
                            {name}
                          </th>
                        ) : filter === 1 || ordenar === 1 ? (
                          <>
                            <th
                              key={Math.random(20)}
                              scope="col"
                              className="relative col-start-1 row-start-1 py-4 border-b border-gray-300"
                            >
                              <Disclosure
                                as="section"
                                aria-labelledby="filter-heading"
                              >
                                <div className="mx-auto flex max-w-7xl space-x-2 divide-x divide-gray-200 px-1 text-sm sm:px-6 lg:px-4">
                                  <div className="flex flex-row text-sm font-semibold text-grisMira whitespace-pre-wrap">
                                    {filter === 1 &&
                                      <Disclosure.Button className="group flex items-center text-sm font-semibold text-grisMira" onClick={() => handleFilterClose()}
                                      >
                                        <FunnelIcon className={isShowing === true ? "h-5 w-5 flex-none text-secundario" : "h-5 w-5 flex-none text-grisMira"} aria-hidden="true" />
                                        {name}
                                      </Disclosure.Button>
                                    }
                                    {ordenar === 1 &&
                                      <Disclosure.Button className="group flex items-center text-sm font-semibold text-grisMira" onClick={() => handleOrder(isOrden)}>
                                        {isOrden === true ?
                                          <ArrowUpIcon className={isOrden === true ? "h-5 w-5 flex-none text-secundario" : "h-5 w-5 flex-none text-grisMira"} aria-hidden="true" />
                                          : <ArrowDownIcon className={isOrden === true ? "h-5 w-5 flex-none text-secundario" : "h-5 w-5 flex-none text-grisMira"} aria-hidden="true" />
                                        }
                                        {filter === 0 && name}
                                      </Disclosure.Button>}
                                  </div>
                                </div>
                                <Transition
                                  as={Fragment}
                                  show={isShowing}
                                  enter="transition-opacity duration-75"
                                  enterFrom="opacity-0"
                                  enterTo="opacity-100"
                                  leave="transition-opacity duration-150"
                                  leaveFrom="opacity-100"
                                  leaveTo="opacity-0"
                                >
                                  <Disclosure.Panel>
                                    <div className="relative mt-2 flex">
                                      <Combobox as="div" value={selectedPerson} onChange={(value) => handleFilterA(value, id)}>
                                        <div className="relative mt-2">
                                          <Combobox.Input
                                            className="w-full rounded-md border-0 bg-secundarioMira py-1.5 pl-3 pr-10 text-white shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-secundario sm:text-sm sm:leading-6"
                                            displayValue={(person) => Object.values(person)[id]}
                                            onChange={(event) => setQuery(event.target.value)}
                                          />
                                          <Combobox.Button className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
                                            <ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                          </Combobox.Button>
                                          {filteredAlumnos.length > 0 && (
                                            <Combobox.Options className="absolute z-10 mt-1 max-h-60 w-full ||overflow-auto bg-secundarioMira py-1 text-sm font-semibold shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                              {filteredAlumnos?.map((person) => (
                                                <Combobox.Option
                                                  key={Object.values(person)[id]}
                                                  value={person}
                                                  className={({ active }) =>
                                                    classNames(
                                                      'relative cursor-default select-none py-2 pl-8 pr-4',
                                                      active ? 'bg-secundario text-white' : 'text-grisMira'
                                                    )
                                                  }
                                                >
                                                  {({ active, selected }) => (
                                                    <>
                                                      <span className={classNames('block truncate', selected && 'font-semibold')}>{Object.values(person)[id]}</span>

                                                      {selected && (
                                                        <span
                                                          className={classNames(
                                                            'absolute inset-y-0 left-0 flex items-center pl-1.5',
                                                            active ? 'text-white' : 'text-secundario'
                                                          )}
                                                        >
                                                          <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                        </span>
                                                      )}
                                                    </>
                                                  )}
                                                </Combobox.Option>
                                              ))}
                                            </Combobox.Options>
                                          )}
                                        </div>
                                      </Combobox>
                                    </div>
                                  </Disclosure.Panel>
                                </Transition>
                              </Disclosure>
                            </th>
                          </>) : null
                      )}
                    </tr>
                  </thead>
                  <tbody className="bg-primarioMira elementFadeIn1s">
                    {dataAlumnos && dataAlumnos?.map((alumno, Idx) => {
                      //let color = ((alumno?.EstadoColor === null || alumno?.EstadoColor === undefined || alumno?.EstadoColor === '') ? '' : alumno?.EstadoColor)
                      let inscrito =
                        alumno?.EstadoSolicitud === null ||
                          alumno?.EstadoSolicitud === undefined ||
                          alumno?.EstadoSolicitud === ""
                          ? ""
                          : alumno?.EstadoSolicitud;
                      let re_inscrito =
                        reinscrito === null ||
                          reinscrito === undefined ||
                          reinscrito === ""
                          ? false
                          : reinscrito;
                      let IconoS = statuses[alumno?.InscripcionPagada]?.IconoS;
                      return (
                        <tr
                          key={Math.random(1000)}
                          // onClick={() => (inscrito !== 'Inscrito' ? handleAlumno(alumno,) : null)} tipoGrid === "revision_inventario" ? "bg-secundario text-green-400":
                          className={
                            "hover:bg-secundarioMira " +
                            tipoGrid === "asistencia" ? " hover:bg-secundarioMira grid md:table-row ": 
                             tipoGrid === "revision_inventario" ? 
                             alumno.Faltante? " bg-red-500  text-white ": alumno.Sobrante ? " bg-secundario text-white ": "  hover:bg-secundarioMira ":" hover:bg-secundarioMira "
                          }
                        >
                          {columnas?.map(
                            ({
                              id,
                              type,
                              resaltado,
                              pintar,
                              colorTexto,
                              text,
                              name,
                              alt,
                              color,
                              style,
                              icono
                            }) =>
                              id !== 999 ? (
                                <td
                                  key={Math.random(100)}
                                  className={classNames(
                                    id === 0 && position === "portrait"
                                      ? "w-[80%] sticky text-primarioMira bg-primarioMira left-0"
                                      : "whitespace-nowrap",
                                    Idx !== alumnos.length - 1
                                      ? "border-b-2 border-b-gray-500 "
                                      : "",
                                    "py-2 pl-4 pr-3 text-sm font-medium text-white sm:pl-6 lg:pl-8",
                                    pintar === "" ||
                                      pintar === null ||
                                      pintar === undefined
                                      ? ""
                                      : `${pintar} border-b-2 border-b-gray-200`,
                                    style === "" ||
                                      style === null ||
                                      style === undefined
                                      ? ""
                                      : `${style}`
                                  )}
                                >
                                  {resaltado ? (
                                    <p
                                      className={classNames(
                                        color
                                          ? " flex justify-center "
                                          : " place-content-center ",
                                        alumno?.EstadoColor === "" || alumno?.EstadoColor === null || alumno?.EstadoColor === undefined
                                          ? `${color}`
                                          : `${alumno?.EstadoColor}`,
                                        "rounded-full px-8 py-1 lg:w-auto leading-5 place-content-center",
                                        colorTexto === "" ||
                                          colorTexto === null ||
                                          colorTexto === undefined
                                          ? "text-white font-semibold text-sm"
                                          : `${colorTexto} font-bold text-sm`
                                      )}
                                    >
                                      {type === "number"
                                        ? Intl.NumberFormat("es-GT", {
                                          style: "currency",
                                          currency: "GTQ",
                                        }).format(Object.values(alumno)[id])
                                        : Object.values(alumno)[id]}{" "}
                                    </p>
                                  ) : (
                                    <div
                                      className={classNames(
                                        colorTexto === "" ||
                                          colorTexto === null ||
                                          colorTexto === undefined
                                          ? "text-white font-semibold text-sm"
                                          : `${colorTexto} font-bold text-sm`
                                      )}
                                    >
                                      {type === "number" ? (
                                        Intl.NumberFormat("es-GT", {
                                          style: "currency",
                                          currency: "GTQ",
                                        }).format(Object.values(alumno)[id])
                                      ) :
                                        type === "textBox" ? (
                                          <div>
                                            <input
                                              type="number"
                                              //key={Idx}
                                              autoComplete="off"
                                              //ref={(e) => setInventarioRef(e, Idx)}
                                              name={"INVENTARIO" + Idx.toString()}
                                              className={"rounded-md text-black "}
                                              onBlur={(e) => handleGridInput(e, Idx)}
                                              onChange={(e) => handleChangeTextbox(e, Idx)}
                                              value={textos[`INVENTARIO${Idx.toString()}`]}
                                            >
                                            </input>
                                          </div>


                                        )
                                          :
                                          type === "imagen" ? ( //
                                            <div>
                                              <img
                                                src={('./img/cursos/' + Object.values(alumno)[id])}
                                                onError={({ currentTarget }) => {
                                                  currentTarget.onerror = null; // prevents looping
                                                  currentTarget.src = '././img/cursos/defaultImage.jpg';
                                                }}
                                                className="h-12 w-12 //rounded-full"
                                              >
                                              </img>
                                            </div>


                                          )
                                            : type === "link" ? (
                                              Object.values(alumno)[id] !== "#" && (
                                                <a
                                                  href={Object.values(alumno)[id]}
                                                  target="_blank"
                                                  rel="noreferrer"
                                                  className="text-sm font-medium text-azulBrillanteMira hover:text-azulLogos hover:underline"
                                                >
                                                  {/*{alumno.Editado?"modificar":text}*/}
                                                  {text}
                                                </a>
                                              )
                                            )
                                              :
                                              type === "vista" ? (
                                                Object.values(alumno)[id] !== "#" && (
                                                  <a
                                                    href={Object.values(alumno)[id]}
                                                    //target="_blank"
                                                    //rel="noreferrer"
                                                    onClick={() => handleClick(alumno, id)}
                                                    className="text-sm font-medium text-secundario hover:underline cursor-pointer"
                                                  >
                                                    {/*{alumno.Editado?"modificar":text}*/}
                                                    {textoaEnviar(alumno, titulo, text, alt)}
                                                  </a>
                                                )
                                              )
                                              :
                                              type === "unido" ? 
                                                (
                                                  Object.values(alumno)[1] + " " + Object.values(alumno)[2]
                                                  
                                                )
                                              
                                                : type === "swicht" ? (
                                                  <div>
                                                    <Switch
                                                      checked={Object.values(alumno)[id]}
                                                      //value={alumno.Confiable.toString()}
                                                      onChange={(e) => {
                                                        handleAlumno(
                                                          alumno,
                                                          text,
                                                          !Object.values(alumno)[id],
                                                          e
                                                        );
                                                      }}
                                                      className={classNames(
                                                        Object.values(alumno)[id]
                                                          ? "bg-azulBrillanteMira"
                                                          : color
                                                            ? color
                                                            : "bg-gray-200",
                                                        "relative inline-flex h-6 w-12 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-azulBrillanteMira focus:ring-offset-2"
                                                      )}
                                                    >
                                                      <span className="sr-only">
                                                        Use setting
                                                      </span>
                                                      <span
                                                        className={classNames(
                                                          Object.values(alumno)[id]
                                                            ? "translate-x-6"
                                                            : "translate-x-0",
                                                          "pointer-events-none relative inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
                                                        )}
                                                      >
                                                        <span
                                                          className={classNames(
                                                            Object.values(alumno)[id]
                                                              ? "opacity-0 duration-100 ease-out"
                                                              : "opacity-100 duration-200 ease-in",
                                                            "absolute inset-0 flex h-full w-full items-center justify-center transition-opacity"
                                                          )}
                                                          aria-hidden="true"
                                                        >
                                                          <svg
                                                            className={
                                                              "h-3 w-3 text-gray-400"
                                                            }
                                                            fill="none"
                                                            viewBox="0 0 12 12"
                                                          >
                                                            <path
                                                              d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2"
                                                              stroke="currentColor"
                                                              strokeWidth={2}
                                                              strokeLinecap="round"
                                                              strokeLinejoin="round"
                                                            />
                                                          </svg>
                                                        </span>

                                                        <span
                                                          className={classNames(
                                                            Object.values(alumno)[id]
                                                              ? "opacity-100 duration-200 ease-in"
                                                              : "opacity-0 duration-100 ease-out",
                                                            "absolute inset-0 flex h-full w-full items-center justify-center transition-opacity"
                                                          )}
                                                          aria-hidden="true"
                                                        >
                                                          <svg
                                                            className="h-3 w-3 text-azulBrillanteMira"
                                                            fill="currentColor"
                                                            viewBox="0 0 12 12"
                                                          >
                                                            <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
                                                          </svg>
                                                        </span>
                                                      </span>
                                                    </Switch>
                                                    <p className="lg:mr-2 lg:hidden lg:float-none float-right">
                                                      {name === "Presente" ||
                                                        name === "Tarde" ||
                                                        name === "Ausente"
                                                        ? name
                                                        : null}
                                                    </p>
                                                    {/* antes de los puntos se pueden agrear los demas elementos, por ejemplo botones y nuevos tags*/}
                                                  </div>
                                                ) : Object.values(alumno)[id] ===
                                                  "Agregar combo" ? (
                                                  <input
                                                    className=" text-secundario  hover:underline"
                                                    type="button"
                                                    value="Agregar combo"
                                                    onMouseUp={() =>
                                                      handleClick(
                                                        Object.values(alumno.Carnet),
                                                        alumno
                                                      )
                                                    }
                                                  ></input>
                                                ) : name === "No." ? (
                                                  Idx + 1
                                                ) : icono ? (
                                                  <IconoS
                                                    className={classNames(
                                                      statuses[Object.values(alumno)[id]].Texto, "hidden h-6 w-5 flex-none sm:block")}
                                                    aria-hidden="true"
                                                  />
                                                ) : (
                                                  Object.values(alumno)[id]
                                                )}
                                    </div>
                                  )}
                                </td>
                              ) : seleccion && inscrito !== "Inscrito" ? (
                                <td
                                  key={Math.random(100)}
                                  className={classNames(
                                    Idx !== alumnos.length - 1
                                      ? "border-b-2 border-b-gray-500 "
                                      : "",
                                    "relative whitespace-nowrap py-2 pl-4 pr-3 text-left text-sm font-medium sm:pr-6 lg:pl-8 "
                                  )}
                                >
                                  {swicht && Idx === 0 && !re_inscrito ? (
                                    <Switch
                                      checked={enabled}
                                      onChange={() => {
                                        handleAlumno(alumno, text, !enabled);
                                      }}
                                      className={classNames(
                                        enabled
                                          ? "bg-azulBrillanteMira"
                                          : "bg-gray-200",
                                        "relative inline-flex h-6 w-12 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-azulBrillanteMira focus:ring-offset-2"
                                      )}
                                    >
                                      <span className="sr-only">
                                        Use setting
                                      </span>
                                      <span
                                        className={classNames(
                                          enabled
                                            ? "translate-x-6"
                                            : "translate-x-0",
                                          "pointer-events-none relative inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
                                        )}
                                      >
                                        <span
                                          className={classNames(
                                            enabled
                                              ? "opacity-0 duration-100 ease-out"
                                              : "opacity-100 duration-200 ease-in",
                                            "absolute inset-0 flex h-full w-full items-center justify-center transition-opacity"
                                          )}
                                          aria-hidden="true"
                                        >
                                          <svg
                                            className="h-3 w-3 text-gray-400"
                                            fill="none"
                                            viewBox="0 0 12 12"
                                          >
                                            <path
                                              d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2"
                                              stroke="currentColor"
                                              strokeWidth={2}
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            />
                                          </svg>
                                        </span>
                                        <span
                                          className={classNames(
                                            enabled
                                              ? "opacity-100 duration-200 ease-in"
                                              : "opacity-0 duration-100 ease-out",
                                            "absolute inset-0 flex h-full w-full items-center justify-center transition-opacity"
                                          )}
                                          aria-hidden="true"
                                        >
                                          <svg
                                            className="h-3 w-3 text-azulBrillanteMira"
                                            fill="currentColor"
                                            viewBox="0 0 12 12"
                                          >
                                            <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
                                          </svg>
                                        </span>
                                      </span>
                                    </Switch>
                                  ) : //                                                                    showDialogoPlan4?
                               
                                    (!perfil && alumno?.PlanE === 'Plan 4') ? ( // !perfil fue el codigo que se añadió al editar "perfil de alumno", si falla, quitarlo
                                      <>
                                        <>
                                          <button
                                            className={
                                              "w-full rounded-md border border-transparent text-white bg-azulBrillanteMira |focus-within:bg-secundario mt-2 py-2 px-4 text-sm font-medium |hover:bg-secundarioMira hover:border-azulLogos focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-2"
                                            }
                                            onClick={()=> perfil?handleAlumno(alumno, text, !enabled):alumno?.PlanE !== 'Plan 4' && setEstado(0, alumno)}
                                            onMouseEnter={() => handleDropDown(Idx)}
                                          >

                                            Seleccionar
                                          </button>
                                          {perfil?
                                          null:

                                          <div
                                            key={alumno.Carnet}
                                            ref={(e) => addToRefs(e, Idx)}
                                            name="store"
                                            onMouseLeave={() =>
                                              handleDropDown(() => handleDropDown(Idx))
                                            }
                                            className={!dropDown && "hidden"}
                                          >
                                            <ul>
                                              {alumno.Efectivo === 1 &&
                                                <li
                                                  onClick={(e) =>
                                                    setEstado(0, alumno)
                                                  }
                                                  className={
                                                    "hover:bg-azulBrillanteMira hover:rounded-sm p-1 text-white |w-full overflow-hidden hover:cursor-pointer"
                                                  }
                                                >
                                                  Efectivo
                                                </li>
                                              }
                                              {alumno.TC === 1 &&
                                                <li
                                                  onClick={(e) =>
                                                    setEstado(1, alumno)
                                                  }
                                                  className={
                                                    "hover:bg-azulBrillanteMira hover:rounded-sm p-1 text-white |w-full overflow-hidden hover:cursor-pointer"
                                                  }
                                                >
                                                  Tarjeta
                                                </li>
                                              }

                                              {alumno.Deposito === 1 &&
                                                <li
                                                  onClick={(e) =>
                                                    setEstado(2, alumno)
                                                  }
                                                  className={
                                                    "hover:bg-azulBrillanteMira hover:rounded-sm p-1 text-white |w-full overflow-hidden hover:cursor-pointer"
                                                  }
                                                >
                                                  Boleta
                                                </li>
                                              }
                                            </ul>
                                          </div>
                                  }
                                        </>
                                        {/**/}
                                      </>
                                    ) : 
                                    // alumno?.Carnet?.substring(0, 2) === 'CN' && traslado === 0 ? (
                                    //   <>
                                    //     <>
                                    //       <button
                                    //         className={
                                    //           "w-full rounded-md border border-transparent text-white bg-azulBrillanteMira |focus-within:bg-secundario mt-2 py-2 px-4 text-sm font-medium |hover:bg-secundarioMira hover:border-azulLogos focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-2"
                                    //         }
                                    //         //onClick={(e) => setEstado(0, alumno)}
                                    //         onMouseEnter={() => handleDropDown(Idx)}
                                    //       >

                                    //         Seleccionar
                                    //       </button>
                                    //       {isRetiro ?
                                    //         null :
                                    //         <div
                                    //           key={alumno.Carnet}
                                    //           ref={(e) => addToRefs(e, Idx)}
                                    //           name="store"
                                    //           onMouseLeave={() =>
                                    //             handleDropDown(() => handleDropDown(Idx))
                                    //           }
                                    //           className={!dropDown && "hidden"}
                                    //         >
                                    //           <ul>
                                    //             <li
                                    //               onClick={(e) =>
                                    //                 setEstado(1, alumno)
                                    //               }
                                    //               className={
                                    //                 "hover:bg-azulBrillanteMira hover:rounded-sm p-1 text-white |w-full overflow-hidden hover:cursor-pointer"
                                    //               }
                                    //             >
                                    //               Online
                                    //             </li>
                                    //             <li
                                    //               onClick={(e) =>
                                    //                 setEstado(2, alumno)
                                    //               }
                                    //               className={
                                    //                 "hover:bg-azulBrillanteMira hover:rounded-sm p-1 text-white |w-full overflow-hidden hover:cursor-pointer"
                                    //               }
                                    //             >
                                    //               Presencial
                                    //             </li>
                                    //           </ul>
                                    //         </div>
                                    //       }
                                    //     </>
                                    //     {/**/}
                                    //   </>
                                    // ) :
                                    alumno.hasOwnProperty('SubMenu')?
                                    alumno?.SubMenu.length>0 && 
                                     (
                                      <button
                                        type="button"
                                        onClick={() =>
                                          inscrito !== "Inscrito"
                                            ? handleAlumno(
                                              alumno,
                                              textoaEnviar(
                                                alumno,
                                                titulo,
                                                text,
                                                alt
                                              ), Idx
                                            )
                                            : null
                                        }
                                        className={                                          
                                             'focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-2 text-secundario hover:underline'}
                                      >
                                        {textoaEnviar(alumno, titulo, text, alt) + ' de '+ alumno.Nombre.toLowerCase()}
                                        <span className="sr-only">
                                          , {alumno.Carnet}{" "}
                                        </span>
                                      </button>
                                    ):
                                    <button
                                        type="button"
                                        onClick={() =>
                                          inscrito !== "Inscrito"
                                            ? handleAlumno(
                                              alumno,
                                              textoaEnviar(
                                                alumno,
                                                titulo,
                                                text,
                                                alt
                                              )
                                            )
                                            : null
                                        }
                                        className={
                                          text === "Seleccionar" || text === "Continuar"
                                            ? `w-full rounded-md border border-transparent bg-${textoaEnviar(alumno, titulo, text, alt) === "Seleccionar" || "Continuar" ? "azulBrillanteMira" : "secundario"} /mt-2 py-2 px-4 text-sm font-medium text-white  hover:bg-secundarioMira hover:border-azulLogos focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-2`
                                            : "text-secundario hover:underline "
                                        }
                                      >
                                        {textoaEnviar(alumno, titulo, text, alt)}
                                        <span className="sr-only">
                                          , {alumno.Carnet}{" "}
                                        </span>
                                      </button>
                                    }
                                </td>
                              ) :

                               seleccion ? (
                                <td
                                  key={Math.random(100)}
                                  className={classNames(
                                    Idx !== alumnos.length - 1
                                      ? "border-b-2 border-b-gray-500"
                                      : "",
                                    "relative whitespace-nowrap py-2 pr-4 pl-3 text-right text-sm font-medium sm:pr-6 lg:pr-8"
                                  )}
                                ></td>
                              ) : null
                          )}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div >
    </>
  );
};

export default ResultadoDataGrid;
